import request from '@/utils/request'

export const submitVideoSubtitle = (id, data) => request({
  url: `/api/video/records/${id}/subtitle-removal`, method: 'post', data, timeout: 180000
})

// The list card and open detail share an in-flight query for the same video.
const queries = new Map()
export function syncVideoSubtitle(id) {
  const key = String(id)
  if (!queries.has(key)) {
    queries.set(key, request({ url: `/api/video/records/${id}/subtitle-removal`, method: 'get', silent: true, timeout: 20000 })
      .finally(() => queries.delete(key)))
  }
  return queries.get(key)
}

export const selectVideoSubtitle = (id, version) => request({
  url: `/api/video/records/${id}/subtitle-removal/display`, method: 'put', data: { version }
})
